let scrollToTop = (height) => {
    setTimeout(() => {
        window.scrollTo({
            left: 0,
            top: height,
        });
    }, 100)
};

export { scrollToTop };